import React, { useEffect, useState } from "react";
import axios from "axios";
import gmail from "../assets/img/gmail.png";
import { useLocation, useNavigate } from "react-router-dom";
import Resetpassword_page1 from "../assets/img/Resetpassword_page1.png";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { IoMdInformationCircleOutline } from "react-icons/io";
import PasswordIcon from "../assets/img/Password.png"; // your left icon

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
  const query = useQuery();
  const token = query.get("token");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [modal, setModal] = useState({ show: false, message: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [show, setShow] = useState(false);
  const [placement, setPlacement] = useState("top");
  const togglePopover = () => setShow(!show);
  const popover = (
    <Popover id="info-popover">
      <Popover.Header as="h3">Password Policy</Popover.Header>
      <Popover.Body>
        New Password should contain minimum 8 Characters with
        Uppercase,Lowercase and Numbers
      </Popover.Body>
      <Popover.Body>
        New Password and Confirm Password should be same.
      </Popover.Body>
    </Popover>
  );
  const extractEmail = (emailData) => {
    if (typeof emailData === "string") return emailData;
    if (emailData && typeof emailData === "object") {
      return emailData.email || "";
    }
    return "";
  };

  const extractErrorMessage = (data) => {
    if (typeof data === "string") return data;

    if (typeof data === "object" && data !== null) {
      const firstKey = Object.keys(data)[0];
      const value = data[firstKey];
      if (Array.isArray(value)) return value[0];
    }

    return "Invalid or expired link.";
  };

  useEffect(() => {
    if (!token) {
      setModal({ show: true, message: "Reset link is missing." });
      setLoading(false);
      return;
    }

    axios
      .get("/reset-password", { params: { token } })
      .then((res) => {
        if (res.data.type === "success") {
          setTokenValid(true);
          setEmail(extractEmail(res.data.email));
        } else {
          setModal({
            show: true,
            message:
              extractErrorMessage(res.data.message) ||
              "Invalid or expired link.",
          });
        }
      })
      .catch((err) => {
        const message = extractErrorMessage(err.response?.data?.message);
        setModal({
          show: true,
          message: message || "Invalid or expired link.",
        });
      })
      .finally(() => setLoading(false));
  }, [token]);

  // Handle password input change
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    if (!value.trim()) {
      setPasswordError("Password is required");
    } else {
      setPasswordError("");
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/;
    if (!passwordRegex.test(value)) {
      setPasswordError(
        "New Password should contain minimum 8 characters with Uppercase, Lowercase and numbers"
      );
    }

    // recheck confirm password
    if (passwordConfirm && value !== passwordConfirm) {
      setConfirmError("Passwords do not match.");
    } else {
      setConfirmError("");
    }
  };

  // Handle confirm password input change
  const handlePasswordConfirmChange = (e) => {
    const value = e.target.value;
    setPasswordConfirm(value);
    if (!value.trim()) {
      setConfirmError("Confirm Password is required");
    }
    if (value !== password) {
      setConfirmError("Passwords do not match.");
    } else {
      setConfirmError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (passwordError || confirmError) return;
    if (password !== passwordConfirm) {
      setModal({ show: true, message: "Passwords do not match." });
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post("/reset-password", {
        token,
        password,
        password_confirmation: passwordConfirm,
      });

      setTokenValid(false); // hide form
      setModal({
        show: true,
        message:
          extractErrorMessage(res.data.message) || "Password reset successful.",
      });
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      // const message =
      //   err.response?.data?.message ||
      //   "Something went wrong. Unable to update the password.";
      setModal({
        show: true,
        message: extractErrorMessage(err.response?.data?.message),
      });
    } finally {
      setSubmitting(false);
    }
  };
  useEffect(() => {
    const updatePlacement = () => {
      setPlacement(window.innerWidth >= 575 ? "right" : "bottom");
    };

    updatePlacement(); // set on initial load

    window.addEventListener("resize", updatePlacement);
    return () => window.removeEventListener("resize", updatePlacement);
  }, []);
  if (loading) return <div>Checking link...</div>;

  return (
    <div className="container-fluid px-0">
      <div className="row d-flex justify-content-center align-items-center g-0 resetpwd-container">
        <div className="col-12 col-md-6 resetpwd-image-col">
          <img src={Resetpassword_page1} alt="Resetpassword_page1" />
        </div>
        <div className="col-12 col-md-6 resetpwd-form-col">
          <div className="resetpwd-content">
            {tokenValid && (
              <form onSubmit={handleSubmit} className="mt-4">
                <p className="fs-4 fw-normal d-flex align-items-center gap-2 mb-4">
                  Reset Password
                  <OverlayTrigger
                    trigger={["hover", "click", "focus"]}
                    placement={placement}
                    overlay={popover}
                    onToggle={togglePopover}
                    popperConfig={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, 6] } }, // [skewX, skewY] — tweak Y value
                        {
                          name: "preventOverflow",
                          options: { boundary: "viewport" },
                        },
                      ],
                    }}
                    container={document.body} // render popover at body level to avoid parent stacking issues
                    rootClose
                  >
                    <Button
                      variant="link"
                      className="p-0 border-0 d-flex align-items-center justify-content-center text-align-justify"
                      style={{ lineHeight: 1 }}
                    >
                      <IoMdInformationCircleOutline size={22} color="black" />
                    </Button>
                  </OverlayTrigger>
                </p>

                <div className="position-relative mb-3">
                  <img
                    style={{ position: "absolute", top: "23px", left: "10px" }}
                    src={gmail}
                    alt="gmail"
                  ></img>
                  <input
                    type="email"
                    className=" form-control px-5 py-3 mb-2"
                    value={email}
                    readOnly
                  />
                </div>
                {/* New Password Field */}
                <div className="position-relative mb-3">
                  <img
                    style={{ position: "absolute", top: "18px", left: "12px" }}
                    src={PasswordIcon}
                    alt="password"
                  />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control px-5 py-3"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Enter new password"
                  />
                  <i
                    className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "23px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                  {passwordError && (
                    <small className="text-danger">{passwordError}</small>
                  )}
                </div>

                {/* Confirm Password Field */}
                <div className="position-relative mb-3">
                  <img
                    style={{ position: "absolute", top: "18px", left: "12px" }}
                    src={PasswordIcon}
                    alt="password"
                  />
                  <input
                    type={showPasswordConfirm ? "text" : "password"}
                    name="passwordConfirm"
                    className="form-control px-5 py-3"
                    value={passwordConfirm}
                    onChange={handlePasswordConfirmChange}
                    placeholder="Confirm new password"
                  />
                  <i
                    className={`bi ${
                      showPasswordConfirm ? "bi-eye" : "bi-eye-slash"
                    }`}
                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "23px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                  {confirmError && (
                    <small className="text-danger">{confirmError}</small>
                  )}
                </div>
                <div className="resetpwd-submit d-flex justify-content-center align-items-center mb-4">
                  <button
                    type="submit"
                    className="btn btn-primary mt-4 w-50"
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Reset Password"}
                  </button>
                </div>
              </form>
            )}

            {/* Modal */}
            {modal.show && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header bg-primary text-white">
                      <h5 className="modal-title">Reset Password</h5>
                    </div>
                    <div className="modal-body">
                      <p>{extractErrorMessage(modal.message)}</p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setModal({ ...modal, show: false })}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
